export default import.meta.ROLLDOWN_FILE_URL_rjN0XQ3GPIBCaKLnrJLFMw